module.exports = __webpack_public_path__ + "img/rc-bottom.6bab9082.png";